import { Component, Inject, TemplateRef, ViewChild, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LabmoduleService } from '../../../services/labmodule.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import moment from 'moment';
import { catchError, concatMap, map, switchMap, toArray } from 'rxjs/operators';
import { from, Observable, of } from 'rxjs';

@Component({
  selector: 'upload-report-dialog',
  standalone: true,
  imports: [CommonModule,
    MatIconModule
  ],
  templateUrl: './upload-report-dialog.component.html',
  styleUrl: './upload-report-dialog.component.css'
})
export class UploadReportDialogComponent {
  requisitionData: any;
  uploadedReportLIst: any;
  documentPdfURL: any;
  allfilesTouploadOK: boolean = true;
  fileconvertedtobase64: any = [];
  previewTitle = 'Requisition PDF';
  isViewingUploadedReport = false;
  isPdf = false;
  imageUrl = '';
  selectedReportForDelete: any = null;

  deleteDialogRef!: MatDialogRef<any>;
  @ViewChild('addDeleteModal') addDeleteModal!: TemplateRef<any>;
  isUploadingReports = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<UploadReportDialogComponent>,
    private sanitizer: DomSanitizer, private LabService: LabmoduleService, private dialog: MatDialog
  ) { }

  ngOnInit(): void {

    this.requisitionData = this.data.requisition;

    const fileUrl =
      this.requisitionData?.url
        ? this.requisitionData.url
        : this.requisitionData?.photoURL;

    if (fileUrl) {

      this.isPdf = fileUrl.toLowerCase().includes('.pdf');

      if (this.isPdf) {

        this.documentPdfURL =
          this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);
        this.previewTitle = 'Requisition PDF';

      } else {

        this.imageUrl = fileUrl;
        this.previewTitle = 'Requisition Image';
      }

      console.log("documentPdfURL", this.documentPdfURL, 'imageUrl', this.imageUrl);




    }

    this.getLabReportsByReqId();
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
  deleteFile(index: number): void {

    this.fileconvertedtobase64 =
      this.fileconvertedtobase64.filter(
        (_: any, i: number) => i !== index
      );

  }
  getLabReportsByReqId() {
    var postData = {
      requisitionid: this.requisitionData.id,
    }
    this.LabService.getLabReportsByReqId(postData).subscribe((response: any) => {

      if (response) {
        console.log("get uploaded report", response)
        this.uploadedReportLIst = response.reports

      }

    })

  }
  onFileDropped($event: any) {
    this.fileBrowseHandler($event)

  }


  saveChangesLabReoprt(): void {

    if (this.isUploadingReports) {
      return;
    }

    // ===============================
    // VALIDATE FILES
    // ===============================

    if (!this.allfilesTouploadOK) {
      alert('Please select valid PDF/JPG/PNG files below 10 MB');
      return;
    }

    if (!this.fileconvertedtobase64?.length) {
      alert('Please select at least one report');
      return;
    }

    if (!this.requisitionData) {
      alert('Requisition details missing');
      return;
    }

    // ===============================
    // LAB DETAILS
    // ===============================

    let lab: any = {};

    try {
      lab = JSON.parse(
        localStorage.getItem('LAB_DETAILS') || '{}'
      );
    } catch (error) {
      console.error('Invalid LAB_DETAILS:', error);
    }

    const uploadedBy = lab?.name || 'lab';

    // ===============================
    // DOCTOR / PATIENT / CUSTOMER IDS
    // ===============================

    const doctorId = Number(
      this.requisitionData?.DoctorId ??
      this.requisitionData?.doctorId ??
      this.requisitionData?.doctor?.id
    );

    const patientId = Number(
      this.requisitionData?.PatientId ??
      this.requisitionData?.patientId ??
      this.requisitionData?.Patient?.id
    );

    const customerId = Number(
      this.requisitionData?.Patient?.User?.CustomerId ??
      this.requisitionData?.Patient?.User?.Customer?.id ??
      this.requisitionData?.patientObject?.CustomerId ??
      this.requisitionData?.CustomerId ??
      this.requisitionData?.customerId
    );

    console.log('LAB CHAT IDS:', {
      DoctorId: doctorId,
      PatientId: patientId,
      CustomerId: customerId
    });

    if (
      !Number.isSafeInteger(doctorId) ||
      doctorId <= 0 ||
      !Number.isSafeInteger(patientId) ||
      patientId <= 0
    ) {
      alert('DoctorId or PatientId missing');
      return;
    }

    if (
      !Number.isSafeInteger(customerId) ||
      customerId <= 0
    ) {
      alert('CustomerId missing. Please check requisition details.');
      return;
    }

    // The backend must independently verify the patient,
    // doctor and customer relationship before chat delivery.

    // ===============================
    // LOCK REPORT SETTINGS
    // ===============================

    let lockReports = 0;

    try {
      const services = this.requisitionData?.services;

      const parsedServices =
        typeof services === 'string'
          ? JSON.parse(services)
          : services;

      lockReports = parsedServices?.lockReports ? 1 : 0;

    } catch (error) {
      console.warn('Unable to read lockReports:', error);
    }

    // ===============================
    // UPLOAD FILES SEQUENTIALLY
    // ===============================

    this.isUploadingReports = true;

    const files = [...this.fileconvertedtobase64];

    from(files).pipe(

      concatMap((file: any) => {

        const postData = {
          data: {
            patientId: patientId,
            fileData: file.data,
            documentType: 'Lab Report',
            fileExtension: file.fileext,
            fileName: file.name,
            notes: '',
            uploadedBy: uploadedBy,
            requisitionid: this.requisitionData.id,
            labid: lab?.id,
            documentDate: moment().format('YYYY-MM-DD'),
            isLocked: lockReports
          }
        };

        console.log('LAB UPLOAD START:', file.name);

        // STEP 1: Upload report to lab
        return this.LabService.LabUploadReport(postData).pipe(

          switchMap((uploadResponse: any) => {

            if (
              uploadResponse?.success === false ||
              uploadResponse?.body?.success === false
            ) {
              throw new Error('Lab upload rejected by server');
            }

            console.log(
              'LAB UPLOAD SUCCESS:',
              file.name,
              uploadResponse
            );

            // STEP 2: Send the same file to patient chat
            return this.sendReportToPatientChat(
              doctorId,
              patientId,
              customerId,
              file
            ).pipe(

              map((chatResponse: any) => ({
                fileName: file.name,
                labUploaded: true,
                chatSent: true,
                chatResponse
              })),

              catchError((chatError: any) => {

                console.error(
                  'CHAT SEND FAILED:',
                  file.name,
                  chatError
                );

                return of({
                  fileName: file.name,
                  labUploaded: true,
                  chatSent: false,
                  error: chatError
                });

              })

            );

          }),

          catchError((uploadError: any) => {

            console.error(
              'LAB UPLOAD FAILED:',
              file.name,
              uploadError
            );

            return of({
              fileName: file.name,
              labUploaded: false,
              chatSent: false,
              error: uploadError
            });

          })

        );

      }),

      toArray()

    ).subscribe({

      next: (results: any[]) => {

        this.isUploadingReports = false;

        const uploadedCount = results.filter(
          x => x.labUploaded
        ).length;

        const chatCount = results.filter(
          x => x.chatSent
        ).length;

        console.log('FINAL UPLOAD RESULTS:', results);

        if (
          uploadedCount === files.length &&
          chatCount === files.length
        ) {

          alert(
            `${uploadedCount} report(s) uploaded and sent to doctor chat successfully`
          );

          this.dialogRef.close(true);

        } else {

          alert(
            `Lab uploaded: ${uploadedCount}/${files.length}\n` +
            `Sent to doctor chat: ${chatCount}/${files.length}\n\n` +
            `Please check failed files before retrying.`
          );

          // Keep dialog open for troubleshooting.
          // Do not retry successful uploads automatically.

        }

      },

      error: (error: any) => {

        this.isUploadingReports = false;

        console.error('UPLOAD PROCESS ERROR:', error);

        alert('Unexpected error while uploading reports');

      }

    });

  }

  private sendReportToPatientChat(
    doctorId: number,
    patientId: number,
    customerId: number,
    file: any
  ): Observable<any> {

    // ===============================
    // VALIDATE IDS
    // ===============================

    if (
      !Number.isSafeInteger(doctorId) ||
      doctorId <= 0 ||
      !Number.isSafeInteger(patientId) ||
      patientId <= 0 ||
      !Number.isSafeInteger(customerId) ||
      customerId <= 0
    ) {
      throw new Error('Invalid doctor, patient or customer ID');
    }

    // ===============================
    // CONVERT FILE TO BASE64
    // ===============================

    const rawData = file?.data;

    const base64 =
      typeof rawData === 'string' && rawData.includes(',')
        ? rawData.split(',')[1]
        : rawData;

    if (!base64 || typeof base64 !== 'string') {
      throw new Error('Base64 file data missing');
    }

    // ===============================
    // DETERMINE FILE TYPE
    // ===============================

    const mimeType = String(
      file?.fileext || ''
    ).toLowerCase();

    const allowedTypes = [
      'application/pdf',
      'image/jpeg',
      'image/png'
    ];

    if (!allowedTypes.includes(mimeType)) {
      throw new Error('Unsupported file type: ' + mimeType);
    }

    // ===============================
    // CHAT PAYLOAD
    // ===============================

    const isPdf = mimeType === 'application/pdf';

    const payload = {
      DoctorId: String(doctorId),
      PatientId: String(patientId),
      CustomerId: String(customerId),

      text: isPdf
        ? 'Requisition Report PDF'
        : 'Requisition Report Photo',

      sentBy: 'p',
      seenByPatient: 'y',
      seenByDoctor: 'n',

      createdAt: new Date(),

      doc: base64,
      fileName: file.name,
      fileType: mimeType
    };

    console.log('LAB CHAT MEDIA PAYLOAD:', {
      DoctorId: payload.DoctorId,
      PatientId: payload.PatientId,
      CustomerId: payload.CustomerId,
      sentBy: payload.sentBy,
      seenByDoctor: payload.seenByDoctor,
      fileName: payload.fileName,
      fileType: payload.fileType,
      base64Length: base64.length
    });

    // ===============================
    // SEND MEDIA TO CHAT
    // ===============================

    return this.LabService.uploadMediaForMessaging(payload).pipe(

      map((response: any) => {

        if (
          response?.success === false ||
          response?.body?.success === false
        ) {
          throw new Error('Chat media upload rejected by server');
        }

        console.log(
          'LAB REPORT CHAT SUCCESS:',
          file.name,
          response
        );

        return response;

      })

    );

  }
  viewPdf(url: any) {
    //this.showUploadPdf =(url.name);
    window.open(url.name, '_blank');
  }
  labUplaodLable: string = "Upload"
  onClickGetReport(report: string): void {

    this.previewTitle = 'Uploaded Report';

    this.isViewingUploadedReport = true;

    this.isPdf =
      report?.toLowerCase().includes('.pdf');

    if (this.isPdf) {

      this.documentPdfURL =
        this.sanitizer.bypassSecurityTrustResourceUrl(
          report
        );

      this.imageUrl = '';

    } else {

      this.imageUrl = report;

      this.documentPdfURL = null;

    }

  }
  showRequisitionPdf(): void {

    this.previewTitle = 'Requisition PDF';

    this.isViewingUploadedReport = false;

    const fileUrl =
      this.requisitionData?.url ||
      this.requisitionData?.photoURL;

    this.isPdf =
      fileUrl?.toLowerCase().includes('.pdf');

    if (this.isPdf) {

      this.documentPdfURL =
        this.sanitizer.bypassSecurityTrustResourceUrl(
          fileUrl
        );

      this.imageUrl = '';

    } else {

      this.imageUrl = fileUrl;

      this.documentPdfURL = null;

    }

  }

  getReportFileName(fileName: string): string {

    if (!fileName) {
      return '';
    }

    return fileName.replace(
      /^[A-Za-z]+[.]?\d+\s+\d{1,2}:\d{2}:\d{2}/,
      ''
    );
  }
  openDeletePopup(report: any) {

    this.selectedReportForDelete = report;

    this.deleteDialogRef = this.dialog.open(
      this.addDeleteModal,
      {
        width: '420px',
        disableClose: true
      }
    );
  }

  closeDeleteDialog() {

    this.selectedReportForDelete = null;

    if (this.deleteDialogRef) {
      this.deleteDialogRef.close();
    }
  }
  confirmDeleteReport(): void {

    if (!this.selectedReportForDelete) {
      return;
    }

    const postData = {
      labreportid: this.selectedReportForDelete.id
    };

    this.LabService
      .deleteLabReport(postData)
      .subscribe({

        next: () => {

          this.uploadedReportLIst =
            this.uploadedReportLIst.filter(
              (x: any) =>
                x.id !== this.selectedReportForDelete.id
            );

          this.selectedReportForDelete = null;

          // this.closeDialog();
          // this.dialog.closeAll();
          if (this.deleteDialogRef) {
            this.deleteDialogRef.close();
          }
        },

        error: (err: any) => {
          console.log(err);
        }

      });

  }
  fileBrowseHandler(files: FileList | File[]): void {

    if (!files || files.length === 0) {
      return;
    }

    this.allfilesTouploadOK = true;

    let services: any = {};

    try {

      const storedDoc = JSON.parse(
        localStorage.getItem('LAB_DOCTOR') || '{}'
      );

      services =
        typeof storedDoc?.services === 'string'
          ? JSON.parse(storedDoc.services)
          : storedDoc?.services || {};

    } catch (error) {

      console.warn('Unable to read LAB_DOCTOR settings:', error);

    }

    const allowedTypes = [
      'application/pdf',
      'image/jpeg',
      'image/png'
    ];

    const maxSize = 10 * 1024 * 1024;

    Array.from(files).forEach((file: File) => {

      if (
        !allowedTypes.includes(file.type) ||
        file.size >= maxSize
      ) {

        this.allfilesTouploadOK = false;

        alert(
          `${file.name}: Only PDF/JPG/PNG files below 10 MB are allowed`
        );

        return;

      }

      const patientLastName = String(
        this.requisitionData?.patientLastName || ''
      ).trim().toLowerCase();

      if (
        services?.labuploadchecklastname &&
        patientLastName &&
        !file.name.toLowerCase().includes(patientLastName)
      ) {

        alert(
          `Patient last name "${patientLastName}" not found in ${file.name}`
        );

        return;

      }

      const reader = new FileReader();

      reader.onload = () => {

        if (typeof reader.result !== 'string') {
          console.error('Invalid file data:', file.name);
          return;
        }

        this.fileconvertedtobase64.push({

          data: reader.result,
          fileext: file.type,
          name: file.name

        });

        console.log(
          'FILE READY:',
          file.name,
          'Total:',
          this.fileconvertedtobase64.length
        );

      };

      reader.onerror = () => {

        console.error('FILE READ ERROR:', file.name);

        this.allfilesTouploadOK = false;

      };

      reader.readAsDataURL(file);

    });

  }
}
